import { PayPalButtons } from "@paypal/react-paypal-js";

const PayPalButton = ({ total }) => {
  const amount = Number(total || 0).toFixed(2);

  if (Number(amount) <= 0) return null;

  return (
    <div style={{ maxWidth: "260px" }}>
      <PayPalButtons
        id="paypal-btn"
        style={{
          layout: "vertical",
          height: 40,
          shape: "pill",
          color: "black",
          label: "pay",
        }}
        fundingSource="paypal"
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: amount,
                },
              },
            ],
          });
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {
            alert("Gracias por tu compra " + details.payer.name.given_name);
          });
        }}
      />
    </div>
  );
};

export default PayPalButton;
